import { VgApiResult, vgApiRequest } from "./vg-api.service";

export type OrgDashboardSummary = {
  orgId: number;
  serviceOrderCount?: number;
  paymentCount?: number;
  outstandingInvoiceCount?: number;
  rCount?: number;
};

function pickDashboard(data: Record<string, unknown> | null | undefined): OrgDashboardSummary | null {
  if (!data) return null;
  return {
    orgId: Number(data.orgId ?? data.OrgId ?? 0),
    serviceOrderCount:
      data.serviceOrderCount != null ? Number(data.serviceOrderCount) : undefined,
    paymentCount: data.paymentCount != null ? Number(data.paymentCount) : undefined,
    outstandingInvoiceCount:
      data.outstandingInvoiceCount != null
        ? Number(data.outstandingInvoiceCount)
        : undefined,
    rCount: data.rCount != null ? Number(data.rCount) : undefined,
  };
}

export async function readOrgDashboard(
  accessToken: string,
  orgId: number
): Promise<VgApiResult<OrgDashboardSummary | null>> {
  const { data, error } = await vgApiRequest<Record<string, unknown>>(
    accessToken,
    "Read_Org_Dashboard_By_Org_ID",
    { orgId }
  );
  if (error) return { data: null, error };
  return { data: pickDashboard(data), error: null };
}
